// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as JsxRuntime from "react/jsx-runtime";

function PriceRetailTableCell(props) {
  let taxIncluded = props.taxIncluded;
  let valueExcludingTax = props.valueExcludingTax;
  let value = taxIncluded ? props.valueIncludingTax : valueExcludingTax;
  let formattedRetailPrice = I18n.currencyFormat(undefined, "EUR", undefined, undefined, value) + Stdlib_Option.mapOr(props.capacityUnit, "", unit => `/` + unit);
  let tmp;
  if (taxIncluded) {
    let formattedValueExcludingTax = I18n.currencyFormat(undefined, "EUR", undefined, undefined, valueExcludingTax) + " " + I18n.t("HT");
    tmp = JsxRuntime.jsx(TextStyle.make, {
      children: formattedValueExcludingTax,
      variation: "normal",
      size: "xxsmall"
    });
  } else {
    tmp = null;
  }
  return JsxRuntime.jsxs(Stack.make, {
    children: [
      JsxRuntime.jsx(TextStyle.make, {
        children: formattedRetailPrice
      }),
      tmp
    ],
    space: taxIncluded ? "xxsmall" : "none"
  });
}

let make = React.memo(PriceRetailTableCell);

export {
  make,
}
/* make Not a pure module */
